/** Recharts exposes tooltip data as unknown; these guards validate fields before formatting them. */

export type RechartsTooltipPayload = ReadonlyArray<{ payload?: unknown }>;

const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" && value !== null;

export const firstPayloadDatum = <T>(
	payload: RechartsTooltipPayload | undefined,
	guard: (value: unknown) => value is T,
): T | undefined => {
	const datum = payload?.[0]?.payload;
	return guard(datum) ? datum : undefined;
};

export type DatePoint = { date: string; value: number };

export const isDatePoint = (value: unknown): value is DatePoint =>
	isRecord(value) && typeof value.date === "string" && typeof value.value === "number";

export type YearRow = {
	year: number;
	selected: number | null;
	comparison: number | null;
};

const isNullableNumber = (value: unknown): value is number | null =>
	value === null || typeof value === "number";

export const isYearRow = (value: unknown): value is YearRow =>
	isRecord(value) &&
	typeof value.year === "number" &&
	isNullableNumber(value.selected) &&
	isNullableNumber(value.comparison);
